import React from "react";
import DefaultButton from '../../../components/DefaultButton'
import { useModal } from "../../../contexts/ModalContext";
export default function SmallBoost({data}){
  const {openQueryModal} = useModal();

  return(
    <>
    <section className="small-boost-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="small-boost-mainbox">
              <img src="/assets/images/small-boost-image.webp" alt="small-boost-image" />
              <div className="small-boost-text">
                <h3 className="heading">{data?.heading}</h3>
                <p>{data?.description}</p>
                <DefaultButton to={data?.slug} onClick={openQueryModal} text={data?.btn} color />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  )
}